import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export const Footer = () => (
  <footer className="py-12 border-t border-border" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 md:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
        <span className="flex items-center gap-3 font-display text-lg font-medium">
          <LogoMark className="h-6 w-6" /> MKSL Consulting
        </span>
        <span className="text-sm text-muted-foreground">© {new Date().getFullYear()} Alle Rechte vorbehalten</span>
      </div>
      <div className="flex items-center gap-6">
        <Link to="/impressum" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-impressum-link">Impressum</Link>
        <Link to="/datenschutz" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-datenschutz-link">Datenschutz</Link>
      </div>
    </div>
  </footer>
);
